import { render, staticRenderFns } from "./ReportersTable.vue?vue&type=template&id=051d3cd8"
import script from "./ReportersTable.vue?vue&type=script&lang=js"
export * from "./ReportersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports